import React from 'react';

const LAYOUTS = [
    {
        id: 'swiggy_cards',
        name: 'Swiggy Cards',
        desc: 'Rich layout with horizontal category scrolls and large dish images.',
        icon: 'view_carousel'
    },
    {
        id: 'zomato_compact',
        name: 'Zomato Compact',
        desc: 'Dense, vertical list optimization for large menus.',
        icon: 'view_list'
    },
    {
        id: 'grid',
        name: 'Photo Grid',
        desc: 'Instagram-style 2-column square photo grid.',
        icon: 'grid_view'
    },
    {
        id: 'list',
        name: 'Elegant List',
        desc: 'Minimalist typography, text-first with no images.',
        icon: 'notes'
    },
    {
        id: 'pdf_style',
        name: 'PDF Print Style',
        desc: 'Clean, printable classical menu aesthetic.',
        icon: 'picture_as_pdf'
    }
];

export default function LayoutSelector({ value, onChange, primaryColor = '#F9D81A' }) {
    // A helper to generate a faint version of the primary color for backgrounds
    const primaryLight = `${primaryColor}20`; 
    // const primaryBorder = `${primaryColor}40`; // unused


    return (
        <div className="flex flex-col bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
            {/* Options List Only */}
            <div className="w-full flex flex-col z-10 bg-white">
                <div className="p-4 border-b border-slate-100 bg-slate-50/50">
                    <h3 className="font-bold text-charcoal text-sm">Select Layout Template</h3>
                </div>
                <div className="flex-1 p-2 flex flex-col gap-1 overflow-y-auto max-h-[350px]">
                    {LAYOUTS.map((layout) => {
                        const isActive = value === layout.id;
                        return (
                            <button
                                key={layout.id}
                                onClick={() => onChange(layout.id)}
                                className={`text-left p-3 rounded-xl flex items-start gap-4 transition-colors duration-200 border-2 relative
                                    ${isActive 
                                        ? 'border-transparent bg-slate-50 shadow-sm' 
                                        : 'border-transparent hover:bg-slate-50'}`}
                                style={isActive ? { borderColor: primaryColor, backgroundColor: primaryLight } : {}}
                            >
                                <div 
                                    className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 transition-colors
                                        ${isActive ? 'text-charcoal' : 'bg-slate-100 text-slate-500'}`}
                                    style={isActive ? { backgroundColor: primaryColor } : {}}
                                >
                                    <span className="material-symbols-outlined">{layout.icon}</span>
                                </div>
                                <div className="flex-1 pt-0.5 min-w-0">
                                    <h4 className={`font-bold text-sm truncate pr-6 ${isActive ? 'text-charcoal' : 'text-slate-700'}`}>
                                        {layout.name}
                                    </h4>
                                    <p className="text-xs text-slate-500 mt-0.5 leading-snug pr-4">
                                        {layout.desc}
                                    </p>
                                </div>
                                {isActive && (
                                    <div className="absolute top-4 right-4 w-5 h-5 rounded-full flex items-center justify-center text-white shadow-sm shrink-0" style={{ backgroundColor: primaryColor }}>
                                        <span className="material-symbols-outlined text-[14px] font-bold text-charcoal">check</span>
                                    </div>
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
